import Vue from 'vue';
import qs from 'qs';
import axios from 'axios/dist/axios.min.js';

axios.defaults.withCredentials = true;

const excludeProxyList = ['ufosdk.baidu.com'];

// 排除代理的域名列表
const isInExcludeProxyList = url => {
    return excludeProxyList.some(excludeUrl => url.includes(excludeUrl));
};

// 构建默认参数
let defaultParams = function () {
    let params = {
        ajax: 1
    };
    try {
        if (window._pageData.bdstoken) {
            params.bdstoken = window._pageData.bdstoken;
        }

    }
    catch (e) {
        params = {};
    }
    return params;
};

axios.interceptors.request.use(function (config) {
    let prefix = config.url.indexOf('?') === -1 ? '?' : '&';
    const isProxy = config.url.indexOf(':') >= 0 && process.env.NODE_ENV !== 'mock';
    if (isProxy && !isInExcludeProxyList(config.url)) {
        const proxyData = config.url.split(':');
        config.url = '/bp/plugin/proxy?url=' + proxyData[0] + ':' + encodeURIComponent(proxyData[1]);
        config.params && (config.url += '&params=' + encodeURIComponent(JSON.stringify(config.params)));
        config.data && (config.url += '&params=' + encodeURIComponent(JSON.stringify(config.data)));
        // config.data && (config.url += '&data=' + encodeURIComponent(JSON.stringify(config.data)));
    }
    // post等请求body
    if (config.data instanceof Object) {
        if (!(config.data instanceof (window.FormData || function () {}))) {
            config.data = qs.stringify(config.data);
        }
    }
    // 所有请求附带默认参数
    let queryString = qs.stringify(defaultParams());
    if (queryString) {
        config.url += prefix + queryString;
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

axios.defaults.validateStatus = function (status) {
    if (status > 400) {
        console.warn(`HTTP 请求出错 status:${status}`);
    }
    return status >= 200 && status <= 505;
};

// 接口
axios.interceptors.response.use(response => {
    // 兼容后端跳转
    // if (response.status === 200) {
    //     if (response.data.code !== 0 && /^http/i.test(response.data.data)) {
    //         window.location.href = response.data.data;
    //     }
    // }

    // if (!response.data || typeof response.data === 'string') {
    //     let msg = '后端接口数据返回为空';
    //     console.warn('接口异常，', 'HTTP状态码：', response.status);
    //     if (!response.data) {
    //         console.error(msg);
    //     }
    //     response.data = {
    //         code: response.status,
    //         msg: msg
    //     };
    // }
    // else if (response.status > 300) {

    //     console.error('HTTP请求出错，状态码为：', response.status);
    //     console.warn('请求信息：', response);
    //     response.data = {
    //         code: response.status,
    //         msg: `HTTP请求出错，状态码为${response.statusText}`
    //     };
    // }
    // if (Number(response.data.code)) {
    //     return Promise.reject(response);
    // }
    return response && response.data || response;
}, function (error) {
    return Promise.reject(error);
});

Vue.prototype.$http = axios;

export default axios;
